import { getLogger, EXT_EVENTS } from '@cld/upload-widget-common';
import { EVENT_TYPES } from '../common/events';
import {
  selectActiveQueueMeta,
  selectFilesFromQueues,
  selectFileVersions,
  selectHasActiveUploadFile,
  selectIsClearQueueInProgress,
} from '../store/selectors';
import { getQueueFilesDataFromFileId } from '../fileUpload/uploadFileMethods';

const logger = getLogger();

const getChangedFilesData = (newState, prevState) => {
  const prevVersions = selectFileVersions(prevState);
  const newVersions = selectFileVersions(newState);
  const files = {};
  const ids = [];

  if (newVersions !== prevVersions) {
    const newQueueData = selectActiveQueueMeta(newState);
    const isPending = newQueueData && newQueueData.pendingPreCalls;
    const newFiles = selectFilesFromQueues(newState);

    Object.keys(newVersions).forEach((id) => {
      if (
        (prevVersions[id] === undefined || newVersions[id] !== prevVersions[id]) &&
        // push file in case it wasnt present before or version is new and isnt part of a pending queue
        (!isPending || (newQueueData && !~newQueueData.ids.indexOf(id)))
      ) {
        ids.push(id);
        files[id] = newFiles[id];
      }
    });
  }

  return {
    ids,
    files,
    hadPrevious: prevVersions && !!Object.keys(prevVersions).length,
  };
};

const getAllFilesFinished = (
  newState,
  prevState // figure out if there are no more active uploads in this cycle
) => selectHasActiveUploadFile(prevState) && !selectHasActiveUploadFile(newState);

const sendFileFinishEvent = (changedData, sendExternalEvent) => {
  const { files } = changedData;

  changedData.ids
    .filter((id) => files[id].done)
    .forEach((id) => {
      logger.log(`[stateProcessors.filesProcessor]: sending FILE_FINISH external event for: ${id}`);

      sendExternalEvent({
        event: EXT_EVENTS.FILE_FINISH,
        info: {
          ...files[id],
          getPreviewObject: undefined, // dont send this to the client
        },
      });
    });
};

const sendQueuesEndEvent = (changedData, newState, sendExternalEvent) => {
  const filesData = getQueueFilesDataFromFileId(changedData.ids[0], newState);
  logger.log('[stateProcessors.filesProcessor]: sending QUEUES_END event');

  sendExternalEvent({
    event: EXT_EVENTS.QUEUES_END,
    info: {
      files: Object.values(filesData),
    },
  });
};

export default (newState, prevState, uploader, sendExternalEvent) => {
  if (!selectIsClearQueueInProgress(newState)) {
    const changedData = getChangedFilesData(newState, prevState);

    if (changedData.ids.length) {
      uploader.emit(EVENT_TYPES.UPLOADER_FILE_STATUS, {
        ids: changedData.ids,
        files: changedData.files,
      });

      sendFileFinishEvent(changedData, sendExternalEvent);
    }

    if (changedData.hadPrevious && changedData.ids.length) {
      // already seen upload files
      if (getAllFilesFinished(newState, prevState)) {
        // previously there were running files and now no
        sendQueuesEndEvent(changedData, newState, sendExternalEvent);
      }
    }
  }
};
